module.exports = __webpack_public_path__ + "b7800b83d20d301b67a2f684e56f3d04.svg";